/* 🤖 this file was generated by svg-to-ts */
export const matIconNoSim: {
  name: 'no-sim';
  data: string;
} = {
  name: 'no-sim',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21.26 21.21 3.79 3.74 2.38 5.15l2.74 2.74-.12.12V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.88 1.88 1.41-1.41zM7 19V9.77L16.23 19H7zm3.84-14H17v9.11l2 2V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06l1.41 1.41L10.84 5z"/></svg>`
};
